const GraphQLQuery = require('app/graphql/Query');

class RestaurantSelect {

    defaultOptions(){
        return {
            '$select': $('<select/>'),
            'value' : '',
            'labelEmpty' : '-',

            'onChange': function(event,$select){},

            'cacheKey': 'restaurants',

            'except': null,
        };
    }
    constructor(options) {
        this.settings = $.extend(this.defaultOptions(), options);

        this.onChange = this.onChange.bind(this);

        this.$select  = this.settings.$select;
        this.value = this.settings.value;

        this.initialize();
    }

    initialize() {
        var self = this;

        this.$select.on('change',this.onChange);

        let restaurants = window.getFromCache(this.settings.cacheKey);
        if(restaurants){
            this.fillSelect(restaurants);
        }else{
            this.loadData();
        }
    }

    loadData(){
        var self = this;


        let filters = {
        };
        if(this.settings.filters){
            filters = this.settings.filters;
        }

        let parameters = {
            'first': 10000,//to be sure to have all
            'filter': filters,
            'orderBy': 'name',
            'dir': 'ASC',
        };

        let fields = [
            'id',
            'name'
        ];

        let query = new GraphQLQuery({
            //parameters
            'queryType': 'restaurants',
            'parameters': parameters,
            'fields': fields,
            'hasEdges': true,
            'addPageInfo': false,
            'addTotalCount': false,
            //callbacks
            'before': function(){
            },
            'success': function(data){
                let items = data.edges;
                window.addToCache(self.settings.cacheKey,items);
                self.fillSelect(items);
            },
            'error': function(message, data){
                console.error(message,data);
                window.notify(message,"danger");
            },
            'after': function(){
            }
        });

        query.execute();
    }

    fillSelect(restaurants){
        this.restaurants = restaurants;


        this.$select.html('');


        this.$select
        .append(
            $('<option/>')
            .val('')
            .append(this.settings.labelEmpty)
        );

        for(var i in this.restaurants){
            let restaurantItem = this.restaurants[i];

            let value = restaurantItem.node.id;
            let label = restaurantItem.node.name;

            if(this.settings.except != value ){

                let $option = $('<option/>')
                .val(value)
                .append(label);

                if(this.value == value){
                    $option.attr('selected','selected');
                }

                this.$select.append($option);
            }

        }

        if(this.$select.hasClass('select2')){
            this.$select.select2({
                'theme': 'bootstrap-5'
            });
        }
    }

    onChange(event){
        this.value = this.$select.val();

        if(this.$select.hasClass('select2')){
            this.$select.trigger('change.select2');
        }
        this.settings.onChange(event,this.$select);
    }
}

module.exports = RestaurantSelect;

